export function isBindRef(v) {
  if (typeof v !== 'object' || v === null || !('$bind' in v)) return false;
  return typeof v.$bind === 'string';
}
export function isBindMapRef(v) {
  if (typeof v !== 'object' || v === null || !('$bindMap' in v)) return false;
  const map = v.$bindMap;
  if (typeof map !== 'object' || map === null) return false;
  const {
    value,
    key
  } = map;
  return typeof value === 'string' && typeof key === 'string';
}
export function isBoundValue(v) {
  return isBindRef(v) || isBindMapRef(v);
}